import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomerService } from '../../../../account/services/customer.service';
import { ContractSignatoryInterface } from '../../../../account/models/contract-signatory.interface';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { ConstsHelper } from '../../../../../helpers/consts.helper';

@Component({
  selector: 'app-signatories-management',
  standalone: false,
  templateUrl: './signatories-management.component.html',
  styleUrl: './signatories-management.component.css',
})
export class SignatoriesManagementComponent implements OnInit {
  @Input()
  procedureCode: string;

  contractSignatories: Array<ContractSignatoryInterface>;
  action: string|null;
  selectedContractSignatory: ContractSignatoryInterface|null;
  form: FormGroup;
  formSubmitted: boolean;
  errors: any = {
    email: {
      required: `L'adresse email est obligatoire.`,
      pattern: `L'adresse email saisie n'est pas valide.`
    },
    firstname: {
      required: `Le prénom est obligatoire.`,
    },
    lastname: {
      required: `Le nom est obligatoire.`,
    },
    role: {
      required: `La fonction est obligatoire.`,
    },
    isSelected: {
      required: `La fonction est obligatoire.`,
    },
    phoneNumber: {
      required: `Un numéro de téléphone est obligatoire.`,
      pattern: `Veuillez saisir un numéro de téléphone composé de 10 chiffres et commençant par 0.`,
    }
  };

  constructor(
      private store: Store<any>,
      private formBuilder: FormBuilder,
      private customerService: CustomerService
  ) {}

  ngOnInit() {
    this.contractSignatories = [];
    this.action = null;
    this.selectedContractSignatory = null;
    this.customerService.getSignatories().subscribe(response => {
      this.contractSignatories = response;
    });
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  handlePopup(action: string|null, signatory: ContractSignatoryInterface|null) {
    this.form = null;
    this.formSubmitted = false;
    this.action = action;
    this.selectedContractSignatory = signatory;
    if (['add', 'update'].indexOf(action) !== -1) {
      this.initForm()
    }
  }

  initForm() {
    this.form = this.formBuilder.group({});
    let isSelected = 'false';
    if (this.selectedContractSignatory && this.selectedContractSignatory.isSelected) {
      isSelected = 'true';
    }
    this.form.addControl('isSelected', this.formBuilder.control(isSelected, [Validators.required]));
    this.form.addControl('firstname', this.formBuilder.control(this.selectedContractSignatory ? this.selectedContractSignatory.firstname : '', [Validators.required]));
    this.form.addControl('lastname', this.formBuilder.control(this.selectedContractSignatory ? this.selectedContractSignatory.lastname : '', [Validators.required]));
    this.form.addControl('email', this.formBuilder.control(this.selectedContractSignatory ? this.selectedContractSignatory.email : '', [Validators.required, Validators.pattern(ConstsHelper.emailPattern)]));
    this.form.addControl('phoneNumber', this.formBuilder.control(this.selectedContractSignatory ? this.selectedContractSignatory.phoneNumber : '', [Validators.required, Validators.pattern(ConstsHelper.phoneNumberPattern)]));
    this.form.addControl('role', this.formBuilder.control(this.selectedContractSignatory ? this.selectedContractSignatory.role : '', [Validators.required]));
    this.form.addControl('civility', this.formBuilder.control(this.selectedContractSignatory ? this.selectedContractSignatory.civility : 'Mr', [Validators.required]));
  }

  save() {
    this.formSubmitted = true;
    if (this.form.valid) {
      let data = {
        firstname: this.form.get('firstname').value,
        lastname: this.form.get('lastname').value,
        email: this.form.get('email').value,
        phoneNumber: this.form.get('phoneNumber').value,
        role: this.form.get('role').value,
        civility: this.form.get('civility').value,
        isSelected: this.form.get('isSelected').value == 'true'
      } as ContractSignatoryInterface
      if (this.action === 'add') {
        this.customerService.createSignatory(data).subscribe(response => {
          this.ngOnInit();
        });
      } else {
        data = { ...data, id: this.selectedContractSignatory.id };
        this.customerService.updateSignatory(data).subscribe(response => {
          this.ngOnInit();
        });
      }
    }
  }

  delete() {
    this.customerService.deleteSignatory(this.selectedContractSignatory.id).subscribe(response => {
      this.ngOnInit();
    });
  }

  getError(formControlName: string): string {
    let errorMsg = '';
    if (this.form.controls[formControlName].invalid) {
      Object.keys(this.form.controls[formControlName].errors).map(
          key => {
            errorMsg = this.errors[formControlName][key];
          }
      );
    }
    return errorMsg;
  }
}
